export const contentGenerationEnabledSections = [
  'workExperience',
  'projects',
  'summary',
  'certifications',
  'awardsAndHonors',
  'education',
  'volunteerWork',
  'researchExperience',
  'conferences',
];
